export const BUILD_NUM = '20260929'; //must be a number

export let domain;
export let baseURL;
export let wsURL;
export let agancyURL; // frontend domain
if (process.env.NODE_ENV !== 'production') {
    // Local development
    domain = '127.0.0.1:7100';
    baseURL = `http://${domain}`;
    wsURL = `ws://${domain}/ws`;
    agancyURL = `http://localhost:3006`;
} else {
    // Production deploy
    domain = 'agency.aotravelconnect.com';
    baseURL = `https://${domain}`;
    wsURL = `wss://${domain}/ws`;
    agancyURL = `https://${domain}`;
}
export const apiURL = `${baseURL}/api/v1`;
export const apiURL2 = `${baseURL}/api/v2`;

export const SupportEmail = 'support@aotravelconnect.com';
